/**
 * Role Visibility Configuration
 *
 * Configuración de visibilidad de secciones por rol OWLY
 *
 * Equipo OWLY:
 * - CEO: Pablo Gonzalez
 * - CTO: Santiago Serna
 * - CFO: Manuela Gamboa
 * - Product Manager: Juan Numpaque
 * - Marketing Manager: Natalia Sanchez
 * - Customer Success Manager: Andres Martinez
 * - Backend Developer: Camilo Quintero
 * - Frontend Developer: Nicolas Ayala
 * - AI Customer Success Agent: OWLY AI Agent
 */

/**
 * Mapeo de secciones que son read-only para roles específicos
 */
export const READ_ONLY_SECTIONS_BY_ROLE: Record<string, string[]> = {
  'CTO': ['companies', 'owly-billing'],
  'Head of Sales': ['owly-users'],
  'Customer Success Manager': ['owly-users', 'owly-billing'],
  'Product Manager': ['companies', 'owly-users'],
  'Marketing Manager': ['companies', 'owly-users'],
  'DevOps Engineer': ['owly-users', 'owly-billing', 'owly-analytics'],
  'Data Analyst': ['companies', 'owly-billing'],
  'Support Engineer': ['companies'],
};

/**
 * Mapeo de secciones visibles por rol OWLY
 */
export const VISIBLE_SECTIONS_BY_ROLE: Record<string, string[]> = {
  'CFO': [
    'owly-dashboard',
    'companies',
    'owly-billing',
    'owly-analytics',
  ],
  'AI Customer Success Agent': [
    'owly-dashboard',
    'companies',
    'owly-support',
    'owly-analytics',
  ],
  'CEO': [
    'owly-dashboard',
    'companies',
    'owly-users',
    'owly-billing',
    'owly-analytics',
    'owly-support',
    'owly-system',
    'owly-monitoring',
    'owly-development',
  ],
  'CTO': [
    'owly-dashboard',
    'companies',
    'owly-users',
    'owly-billing',
    'owly-analytics',
    'owly-support',
    'owly-system',
    'owly-monitoring',
    'owly-development',
  ],
  'Head of Sales': [
    'owly-dashboard',
    'companies',
    'owly-users',
    'owly-billing',
    'owly-analytics',
    'owly-support',
  ],
  'Customer Success Manager': [
    'owly-dashboard',
    'companies',
    'owly-users',
    'owly-billing',
    'owly-analytics',
    'owly-support',
  ],
  'Product Manager': [
    'owly-dashboard',
    'companies',
    'owly-users',
    'owly-analytics',
    'owly-support',
    'owly-monitoring',
    'owly-development',
  ],
  'Marketing Manager': [
    'owly-dashboard',
    'companies',
    'owly-users',
    'owly-analytics',
  ],
  'DevOps Engineer': [
    'owly-dashboard',
    'companies',
    'owly-users',
    'owly-billing',
    'owly-analytics',
    'owly-support',
    'owly-system',
    'owly-monitoring',
    'owly-development',
  ],
  'Backend Developer': [
    'owly-dashboard',
    'companies',
    'owly-support',
    'owly-monitoring',
    'owly-development',
  ],
  'Frontend Developer': [
    'owly-dashboard',
    'companies',
    'owly-analytics',
    'owly-support',
    'owly-monitoring',
    'owly-development',
  ],
  'Data Analyst': [
    'owly-dashboard',
    'companies',
    'owly-billing',
    'owly-analytics',
    'owly-support',
  ],
  'Support Engineer': [
    'owly-dashboard',
    'companies',
    'owly-support',
    'owly-monitoring',
  ],
};

/**
 * Determinar si una sección es read-only para un rol específico
 */
export const isReadOnlyForRole = (sectionId: string, jobTitle: string | undefined): boolean => {
  if (!jobTitle) return false;
  return READ_ONLY_SECTIONS_BY_ROLE[jobTitle]?.includes(sectionId) || false;
};

/**
 * Obtener secciones visibles para un rol específico
 */
export const getVisibleSectionsForRole = (jobTitle: string | undefined): string[] => {
  if (!jobTitle) return [];
  return VISIBLE_SECTIONS_BY_ROLE[jobTitle] || [];
};
